module.exports = __webpack_public_path__ + "static/media/1.c9de8752.svg";